import React, { useState } from 'react';
import IdentificationPage from "./pages/IdentificationPage";
import VotingPage from "./pages/VotingPage";

function App() {
  const [voter, setVoter] = useState<{ firstname: string; lastname: string, hasVoted: boolean } | null>(null);

  return (
    <div className="app-container">
      {!voter ? (
        <IdentificationPage onSubmit={setVoter} />
      ) : (
        <VotingPage voter={voter} />
      )}
    </div>
  );
}

export default App;
